<section class="page-container">
  <div class="flex min-w-0 items-center justify-between gap-4">
    <h1 class="main-heading min-w-0">
      User Management - <span>{{ mode }}</span>
    </h1>
    <app-navpath class="hidden md:block" />
  </div>
  <div
    class="mb-2 flex w-full flex-col gap-1 md:w-fit md:flex-row"
    *ngIf="mode == 'Detail'"
  >
    <button
      class="shorter-btn misc-btn"
      (click)="updateUser()"
      [disabled]="!isFormValid()"
    >
      <fa-icon [icon]="faPencil" class="mr-1"></fa-icon>Update User
    </button>
    <button
      class="shorter-btn clear-btn"
      routerLink="../../../administration/user-management"
    >
      <fa-icon [icon]="faBan" class="mr-1"></fa-icon>Cancel
    </button>
  </div>
  <div
    class="mb-2 flex w-full flex-col gap-1 md:w-fit md:flex-row"
    *ngIf="mode == 'Add'"
  >
    <button
      class="shorter-btn misc-btn"
      (click)="addUser()"
      [disabled]="!isFormValid()"
    >
      <fa-icon [icon]="faPlus" class="mr-1"></fa-icon>Add User
    </button>
    <button
      class="shorter-btn clear-btn"
      routerLink="../../../administration/user-management"
    >
      <fa-icon [icon]="faBan" class="mr-1"></fa-icon>Cancel
    </button>
  </div>
  <div class="content-container">
    <app-data-form
      [dataFields]="user"
      dataName="formFields"
      (updateFields_child)="updateFields($event)"
    />
  </div>
</section>
